import React from 'react';
import NProgress from 'nprogress';
import Router from 'next/router';

export function startProgress() {
    NProgress.start();
}

export function doneProgress() {
    NProgress.done();
}

Router.onRouteChangeStart = () => startProgress();
Router.onRouteChangeComplete = () => doneProgress();
Router.onRouteChangeError = () => doneProgress();

export default function CustomNProgress() {
    return (
        <style
            dangerouslySetInnerHTML={{
                __html: `
                    #nprogress {
                        pointer-events: none;
                    }

                    #nprogress .bar {
                        background: #feb940;
                        position: fixed;
                        z-index: 999999;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 2px;
                    }

                    #nprogress .peg {
                        display: block;
                        position: absolute;
                        right: 0px;
                        width: 100px;
                        height: 100%;
                        box-shadow: 0 0 10px #feb940, 0 0 5px #feb940;
                        opacity: 1.0;
                        -webkit-transform: rotate(3deg) translate(0px, -4px);
                        -ms-transform: rotate(3deg) translate(0px, -4px);
                        transform: rotate(3deg) translate(0px, -4px);
                    }
                `}
            }
        />
    );
}
